import { useMemo, useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';
import { AnimatePresence } from 'framer-motion';

import NoFiltersPanel from '@/components/no-filters-panel/NoFiltersPanel';

import { useWindowSize } from '@/hooks/utils/useWindowResize';

import Actionbar from './components/action-bar/Actionbar';
import ChartPanel from './components/panels/chart-panel/ChartPanel';
import TablePanel from './components/panels/table-panel/TablePanel';
import { useConsumerView } from './hooks/api/useConsumerView';

import * as styles from './ConsumerView.css';

export default function ConsumerView() {
  const [width] = useWindowSize();
  const actionBarRef = useRef<HTMLElement>(null);
  // @ts-ignore
  const { height = 0 } = useResizeObserver({ ref: actionBarRef });
  const isSmallScreen = useMemo(() => width < 900, [width]);
  const calculatedHeight = useMemo(() => `calc(100% - ${height + 15}px)`, [height]);
  const {
    chartData,
    tableData,
    isLoading,
    canLoadData,
    loadData,
    mutateChart,
    mutateTable,
    exportData,
    isExporting,
    isChartFetching,
  } = useConsumerView();

  return (
    <div className={styles.root}>
      <Actionbar
        // @ts-ignore
        ref={actionBarRef}
        canLoadData={Boolean(canLoadData)}
        loadData={loadData}
        isLoading={isLoading}
        exportData={exportData}
        isExporting={isExporting}
        tableData={tableData}
        isSmallScreen={isSmallScreen}
      />
      <div className={styles.content} style={{ height: calculatedHeight, position: 'relative' }}>
        <AnimatePresence mode="wait">
          {!tableData ? (
            <NoFiltersPanel key="no-filters" />
          ) : (
            <>
              <TablePanel
                key="table-panel"
                tableData={tableData}
                isLoading={isLoading}
                mutateChart={mutateChart}
                mutateTable={mutateTable}
              />
              <ChartPanel key="chart-panel" chartData={chartData} isFetching={isChartFetching} />
            </>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
